/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 50,
  image: "default-changelog-v2.png",
  title: "ZK Sync Payments, GPU Support, Auto Scaling, Metric, Platform Fixes & Improvements",
  shortDescription: "The platform has introduced several key updates: integration of ZkSync Chain for smooth transactions using USDT, USDC, and DAI, addition of advanced Nvidia GPUs to enhance AI and computational capabilities, and the launch of Autoscale Compute for dynamic resource allocation. Additionally, new Instance Metrics provide detailed performance insights, and various platform improvements and fixes have been implemented, including PNPM support, domain and CDN bandwidth enhancements, and user experience optimizations.",
  description: "The platform has introduced several key updates: integration of ZkSync Chain for smooth transactions using USDT, USDC, and DAI, addition of advanced Nvidia GPUs to enhance AI and computational capabilities, and the launch of Autoscale Compute for dynamic resource allocation. Additionally, new Instance Metrics provide detailed performance insights, and various platform improvements and fixes have been implemented, including PNPM support, domain and CDN bandwidth enhancements, and user experience optimizations.",
  date: "Nov 13th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Zk Sync Payments
We are pleased to announce the integration of **ZkSync Chain** into our payment options. This addition allows for the smooth processing of transactions using **USDT**, **USDC**, and **DAI**. Users can now effortlessly link their MetaMask wallets and select ZkSync as their payment method to enjoy a range of subscription benefits and additional bonuses. This advancement represents our commitment to providing state-of-the-art financial tools and enhancing user experience.

## GPU Support

We have expanded our hardware capabilities by integrating a suite of advanced **Nvidia GPUs** into Spheron Compute.
This new offering includes the high-performance GPUs:

- **Nvidia RTX 3090**
- **Nvidia RTX 3080**
- **Nvidia A4000**
- **Nvidia T4**

These enhancements are tailored to meet the demands of intensive AI and computational workloads, enabling users to leverage cutting-edge technology for accelerated cloud-based operations.

## Auto Scaling

With the introduction of Autoscale Compute, we're setting a new standard for resource management. This feature is engineered to dynamically allocate resources in alignment with real-time application demands, ensuring that performance is maintained at an optimal level. By selecting the Autoscale option, clients can benefit from a system that scales with their needs, guaranteeing efficiency and superior resource utilization.

## Metrics

Our newly introduced Instance Metrics provide detailed insights into the performance of your provisioned instances. This feature allows for meticulous monitoring of CPU and RAM usage, offering a comprehensive overview that supports informed decision-making. Accessible from the Metrics tab on the Instance page, this tool reflects our dedication to transparency and client empowerment.

## Platform Improvements & Fixes

- **PNPM Support:** We have added support for PNPM package manager. You can now seamlessly deploy your websites using PNPM alongside your preferred package management tools.
- **Domain Improvement on Storage:** Enabled Bucket domains to point to IPNS Links.
- **Compute CDN Bandwidth:** Included CDN bandwidth in the compute usage reports for better monitoring.
- **Referral System Fix:** Corrected an issue where referral codes were not being applied during new user registrations.
- **Marketplace Templates:** Introduced the option to pre-select recommended and persistent storage solutions.
- **Plan Search Input:** Improved the display to show an empty plans page when no plans are available.
- **Responsive View Support:** Implemented a support message for non-desktop screens to enhance user experience.
- **Shardeum Node Addition:** Added the Shardeum Node for the Latest Testnet to our marketplace offerings.
- **Instance Update Fix:** Resolved a problem where instances created from marketplace apps were not updating correctly.
- **UX Enhancements:** Conducted a series of user experience improvements, including fixing loader issues, updating labels, and resolving bugs in the dark theme.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
